<template>
  <v-container class="pa-0" fluid>
    <v-row no-gutters>
      <v-col cols="2">
        <v-navigation-drawer :height="$store.state.windowSize.y - 50" class="grey lighten-3" width="100%" permanent>
          <v-list>
            <h3 v-if="showSectionCompany()" class="pl-4 pt-2">{{ $tc('label.company') }}</h3>

            <!-- Zamestnanci -->
            <v-list-item
              v-if="$store.state.auth.userSettings.accEmployees.read"
              @click="swapComponent('employees')"
              v-bind:class="{
                'brown lighten-4': currentComponent == 'employees',
              }"
            >
              <v-tooltip right :open-delay="1000">
                <template v-slot:activator="{ on }">
                  <v-list-item-icon v-on="on">
                    <v-icon>{{ mdiAccountGroup }} </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content v-on="on">
                    <v-list-item-title>{{ $tc('label.employee', 1) }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <span v-html="$t('tt.settingsEmployees')" />
              </v-tooltip>
            </v-list-item>

            <!-- Skupiny pro planovani -->
            <v-list-item
              v-if="$store.state.auth.userSettings.accEmployeeGroups.read && $store.state.auth.settings.planVisits"
              @click="swapComponent('employeeGroups')"
              v-bind:class="{
                'brown lighten-4': currentComponent == 'employeeGroups',
              }"
            >
              <v-tooltip right :open-delay="1000">
                <template v-slot:activator="{ on }">
                  <v-list-item-icon v-on="on">
                    <v-icon>{{ mdiAccountMultipleCheck }} </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content v-on="on">
                    <v-list-item-title>{{ $tc('label.planningGroup', 2) }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <span v-html="$t('tt.settingsEmployeeGroups')" />
              </v-tooltip>
            </v-list-item>

            <!-- Prostory -->
            <v-list-item
              v-if="$store.state.auth.userSettings.accAreas.read"
              @click="swapComponent('areas')"
              v-bind:class="{ 'brown lighten-4': currentComponent == 'areas' }"
            >
              <v-tooltip right :open-delay="1000">
                <template v-slot:activator="{ on }">
                  <v-list-item-icon v-on="on">
                    <v-icon>{{ mdiHomeCity }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content v-on="on">
                    <v-list-item-title>{{ $tc('label.area', 2) }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <span v-html="$t('tt.settingsAreas')" />
              </v-tooltip>
            </v-list-item>

            <hr v-if="showSectionCompany()" />
            <h3 v-if="showSectionVisitors()" class="pl-4 pt-2">{{ $tc('label.visitor', 2) }}</h3>

            <!-- Navstevy / Osoby -->
            <v-list-item
              v-if="$store.state.auth.userSettings.accVisitors.read"
              @click="swapComponent('visitors')"
              v-bind:class="{
                'brown lighten-4': currentComponent == 'visitors',
              }"
            >
              <v-tooltip right :open-delay="1000">
                <template v-slot:activator="{ on }">
                  <v-list-item-icon v-on="on">
                    <v-icon>{{ mdiBadgeAccountHorizontal }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content v-on="on">
                    <v-list-item-title>{{ $tc('label.visitor', 2) }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <span v-html="$t('tt.settingsVisitors')" />
              </v-tooltip>
            </v-list-item>

            <!-- Firmy -->
            <v-list-item
              v-if="$store.state.auth.userSettings.accCompanies.read"
              @click="swapComponent('companies')"
              v-bind:class="{
                'brown lighten-4': currentComponent == 'companies',
              }"
            >
              <v-tooltip right :open-delay="1000">
                <template v-slot:activator="{ on }">
                  <v-list-item-icon v-on="on">
                    <v-icon>{{ mdiOfficeBuilding }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content v-on="on">
                    <v-list-item-title>{{ $tc('label.company', 2) }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <span v-html="$t('tt.settingsCompanies')" />
              </v-tooltip>
            </v-list-item>

            <!-- Auta / SPZ -->
            <v-list-item
              v-if="$store.state.auth.userSettings.accCars.read"
              @click="swapComponent('cars')"
              v-bind:class="{ 'brown lighten-4': currentComponent == 'cars' }"
            >
              <v-tooltip right :open-delay="1000">
                <template v-slot:activator="{ on }">
                  <v-list-item-icon v-on="on">
                    <v-icon>{{ mdiCarSide }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content v-on="on">
                    <v-list-item-title>{{ $tc('label.car', 2) }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <span v-html="$t('tt.settingsCars')" />
              </v-tooltip>
            </v-list-item>

            <hr v-if="showSectionVisitors()" />
            <h3 v-if="showSectionConfig()" class="pl-4 pt-2">{{ $t('label.configuration') }}</h3>

            <v-list-item
              v-if="$store.state.auth.userSettings.accUsers.read"
              @click="swapComponent('users')"
              v-bind:class="{ 'brown lighten-4': currentComponent == 'users' }"
            >
              <v-tooltip right :open-delay="1000">
                <template v-slot:activator="{ on }">
                  <v-list-item-icon v-on="on">
                    <v-icon>{{ mdiAccountMultiple }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content v-on="on">
                    <v-list-item-title>{{ $tc('label.user', 2) }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <span v-html="$t('tt.settingsUsers')" />
              </v-tooltip>
            </v-list-item>

            <!-- Notifikace -->
            <v-list-item
              v-if="$store.state.auth.userSettings.accMessages.read && $store.state.auth.settings.planVisits"
              @click="swapComponent('employeeMessages')"
              v-bind:class="{
                'brown lighten-4': currentComponent == 'employeeMessages',
              }"
            >
              <v-tooltip right :open-delay="1000">
                <template v-slot:activator="{ on }">
                  <v-list-item-icon v-on="on">
                    <v-icon>{{ mdiEmailArrowRight }} </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content v-on="on">
                    <v-list-item-title>{{ $tc('label.notification', 2) }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <span v-html="$t('tt.settingsNotifications')" />
              </v-tooltip>
            </v-list-item>

            <v-list-item
              v-if="$store.state.auth.userSettings.accCards.read"
              @click="swapComponent('cards')"
              v-bind:class="{ 'brown lighten-4': currentComponent == 'cards' }"
            >
              <v-tooltip right :open-delay="1000">
                <template v-slot:activator="{ on }">
                  <v-list-item-icon v-on="on">
                    <v-icon>{{ mdiCreditCardMultiple }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content v-on="on">
                    <v-list-item-title>{{ $tc('label.visitorcard', 2) }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <span v-html="$t('tt.settingsVisitorCards')" />
              </v-tooltip>
            </v-list-item>

            <v-list-item
              v-if="$store.state.auth.userSettings.accItems.read"
              @click="swapComponent('items')"
              v-bind:class="{ 'brown lighten-4': currentComponent == 'items' }"
            >
              <v-tooltip right :open-delay="1000">
                <template v-slot:activator="{ on }">
                  <v-list-item-icon v-on="on">
                    <v-icon>{{ mdiBagPersonal }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content v-on="on">
                    <v-list-item-title>{{ $tc('label.itemForInspection', 2) }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <span v-html="$t('tt.settingsItemsForInspection')" />
              </v-tooltip>
            </v-list-item>

            <v-list-item
              v-if="$store.state.auth.userSettings.accDocumentTypes.read"
              @click="swapComponent('documentTypes')"
              v-bind:class="{
                'brown lighten-4': currentComponent == 'documentTypes',
              }"
            >
              <v-tooltip right :open-delay="1000">
                <template v-slot:activator="{ on }">
                  <v-list-item-icon v-on="on">
                    <v-icon>{{ mdiCardAccountDetails }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content v-on="on">
                    <v-list-item-title>{{ $tc('label.documentType', 2) }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <span v-html="$t('tt.settingsDocumentTypes')" />
              </v-tooltip>
            </v-list-item>

            <v-list-item
              v-if="$store.state.auth.userSettings.accWorkplaces.read"
              @click="swapComponent('workplaces')"
              v-bind:class="{
                'brown lighten-4': currentComponent == 'workplaces',
              }"
            >
              <v-tooltip right :open-delay="1000">
                <template v-slot:activator="{ on }">
                  <v-list-item-icon v-on="on">
                    <v-icon>{{ mdiMonitorDashboard }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content v-on="on">
                    <v-list-item-title>{{ $tc('label.workplace', 2) }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <span v-html="$t('tt.settingsWorkplaces')" />
              </v-tooltip>
            </v-list-item>

            <v-list-item
              v-if="$store.state.auth.userSettings.accSignTerm.read"
              @click="swapComponent('signTerm')"
              v-bind:class="{
                'brown lighten-4': currentComponent == 'signTerm',
              }"
            >
              <v-tooltip right :open-delay="1000">
                <template v-slot:activator="{ on }">
                  <v-list-item-icon v-on="on">
                    <v-icon>{{ mdiFileSign }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content v-on="on">
                    <v-list-item-title>{{ $tc('label.terminal', 1) }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <span v-html="$t('tt.settingsSignTerm')" />
              </v-tooltip>
            </v-list-item>

            <v-list-item
              v-if="$store.state.auth.userSettings.accMobileDevices.read"
              @click="swapComponent('mobileDevices')"
              v-bind:class="{
                'brown lighten-4': currentComponent == 'mobileDevices',
              }"
            >
              <v-tooltip right :open-delay="1000">
                <template v-slot:activator="{ on }">
                  <v-list-item-icon v-on="on">
                    <v-icon>{{ mdiTabletCellphone }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content v-on="on">
                    <v-list-item-title>{{ $tc('label.mobileDevice', 2) }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <span v-html="$t('tt.settingsMobileDevices')" />
              </v-tooltip>
            </v-list-item>

            <v-list-item
              v-if="$store.state.auth.userSettings.accTemplates.read"
              @click="swapComponent('templates')"
              v-bind:class="{
                'brown lighten-4': currentComponent == 'templates',
              }"
            >
              <v-tooltip right :open-delay="1000">
                <template v-slot:activator="{ on }">
                  <v-list-item-icon v-on="on">
                    <v-icon>{{ mdiFileDocumentMultiple }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content v-on="on">
                    <v-list-item-title>{{ $tc('label.printTemplate', 2) }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <span v-html="$t('tt.settingsPrintTemplates')" />
              </v-tooltip>
            </v-list-item>
            <v-list-item
              v-if="$store.state.auth.userSettings.accSettings.read && $store.state.auth.settings.edoklady"
              @click="swapComponent('edoklady')"
              v-bind:class="{ 'brown lighten-4': currentComponent == 'edoklady' }"
            >
              <v-list-item-icon>
                <v-icon>{{ mdiIdCard }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t('label.edoklady') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="$store.state.auth.userSettings.accSettings.read"
              @click="swapComponent('global')"
              v-bind:class="{ 'brown lighten-4': currentComponent == 'global' }"
            >
              <v-tooltip right :open-delay="1000">
                <template v-slot:activator="{ on }">
                  <v-list-item-icon v-on="on">
                    <v-icon>{{ mdiCogOutline }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content v-on="on">
                    <v-list-item-title>{{ $t('label.system') }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <span v-html="$t('tt.settingsSystem')" />
              </v-tooltip>
            </v-list-item>
          </v-list>
        </v-navigation-drawer>
      </v-col>

      <v-col cols="10">
        <div :is="currentComponent" :swap-component="swapComponent" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import SettingsEmployees from '@/components/settings/Employees.vue';
import SettingsEmployeeGroups from '@/components/settings/EmployeeGroups.vue';
import SettingsMessages from '@/components/settings/Messages.vue';
import SettingsVisitors from '@/components/settings/Visitors.vue';
import SettingsCompanies from '@/components/settings/Companies.vue';
import SettingsCards from '@/components/settings/Cards.vue';
import SettingsAreas from '@/components/settings/Areas.vue';
import SettingsCars from '@/components/settings/Cars.vue';
import SettingsDocumentTypes from '@/components/settings/DocumentTypes.vue';
import SettingsItems from '@/components/settings/Items.vue';
import SettingsWorkplaces from '@/components/settings/Workplaces.vue';
import SettingsSignTerm from '@/components/settings/SignTerm.vue';
import SettingsMobileDevices from '@/components/settings/MobileDevices.vue';
import SettingsUsers from '@/components/settings/Users.vue';
import SettingsTemplates from '@/components/settings/Templates.vue';
import SettingsGlobal from '@/components/settings/Global.vue';
import SettingsEDoklady from '@/components/settings/EDoklady.vue';

import {
  mdiAccountMultiple,
  mdiAccountGroup,
  mdiAccountMultipleCheck,
  mdiBadgeAccountHorizontal,
  mdiCarSide,
  mdiOfficeBuilding,
  mdiHomeCity,
  mdiCreditCardMultiple,
  mdiBagPersonal,
  mdiCardAccountDetails,
  mdiMonitorDashboard,
  mdiTabletCellphone,
  mdiCogOutline,
  mdiAccount,
  mdiEmailArrowRight,
  mdiFileDocumentMultiple,
  mdiFileSign,
  mdiIdCard,
} from '@mdi/js';

export default Vue.extend({
  name: 'SettingsView',
  components: {
    employees: SettingsEmployees,
    employeeGroups: SettingsEmployeeGroups,
    employeeMessages: SettingsMessages,
    companies: SettingsCompanies,
    visitors: SettingsVisitors,
    cards: SettingsCards,
    areas: SettingsAreas,
    cars: SettingsCars,
    documentTypes: SettingsDocumentTypes,
    items: SettingsItems,
    workplaces: SettingsWorkplaces,
    signTerm: SettingsSignTerm,
    mobileDevices: SettingsMobileDevices,
    users: SettingsUsers,
    templates: SettingsTemplates,
    edoklady: SettingsEDoklady,
    global: SettingsGlobal,
  },
  data: () => ({
    currentComponent: '',
    mdiAccountMultiple: mdiAccountMultiple,
    mdiAccountGroup: mdiAccountGroup,
    mdiAccountMultipleCheck: mdiAccountMultipleCheck,
    mdiBadgeAccountHorizontal: mdiBadgeAccountHorizontal,
    mdiCarSide: mdiCarSide,
    mdiOfficeBuilding: mdiOfficeBuilding,
    mdiHomeCity: mdiHomeCity,
    mdiCreditCardMultiple: mdiCreditCardMultiple,
    mdiBagPersonal: mdiBagPersonal,
    mdiCardAccountDetails: mdiCardAccountDetails,
    mdiMonitorDashboard: mdiMonitorDashboard,
    mdiTabletCellphone: mdiTabletCellphone,
    mdiCogOutline: mdiCogOutline,
    mdiAccount: mdiAccount,
    mdiEmailArrowRight: mdiEmailArrowRight,
    mdiFileDocumentMultiple: mdiFileDocumentMultiple,
    mdiFileSign: mdiFileSign,
    mdiIdCard: mdiIdCard,
  }),
  mounted() {
    // this.$store.dispatch('checkLogin').catch(() => this.$router.push('/'));
  },
  methods: {
    swapComponent(component: string) {
      this.currentComponent = component;
    },
    showSectionCompany() {
      if (
        !this.$store.state.auth.userSettings.accEmployees.read &&
        !this.$store.state.auth.userSettings.accEmployeeGroups.read &&
        !this.$store.state.auth.userSettings.accAreas.read
      ) {
        return false;
      } else {
        return true;
      }
    },
    showSectionVisitors() {
      if (
        !this.$store.state.auth.userSettings.accVisitors.read &&
        !this.$store.state.auth.userSettings.accCompanies.read &&
        !this.$store.state.auth.userSettings.accCars.read
      ) {
        return false;
      } else {
        return true;
      }
    },
    showSectionConfig() {
      if (
        !this.$store.state.auth.userSettings.accUsers.read &&
        !this.$store.state.auth.userSettings.accMessages.read &&
        !this.$store.state.auth.userSettings.accCards.read &&
        !this.$store.state.auth.userSettings.accItems.read &&
        !this.$store.state.auth.userSettings.accDocumentTypes.read &&
        !this.$store.state.auth.userSettings.accWorkplaces.read &&
        !this.$store.state.auth.userSettings.accMobileDevices.read &&
        !this.$store.state.auth.userSettings.accSettings.read
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
});
</script>
